var _defs, _sodipodinamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthProfessional({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 126.40613,
    height: 126.406,
    viewBox: "0 0 126.40613 126.406",
    sodipodidocname: "Health professional.ai",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,94.805 H 94.805 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodinamedview || (_sodipodinamedview = /*#__PURE__*/React.createElement("sodipodinamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapegroupmode: "layer",
    inkscapelabel: "Health professional",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,126.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(90.1882,39.161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -0.161,-0.065 c -4.331,-1.748 -6.945,-2.804 -9.136,-4.767 -1.923,-1.722 -7.406,-7.516 -9.618,-10.162 -3.073,-3.677 -10.059,-8.28 -19.633,-9.152 l -2.211,-0.168 c -7.502,-0.571 -16.005,-1.218 -23.333,-1.827 -0.429,-0.036 -0.847,-0.054 -1.251,-0.054 -5.841,0 -9.004,3.633 -9.486,7.232 -0.502,3.746 1.726,8.045 6.954,9.011 0.92,0.204 2.071,0.371 3.29,0.547 1.626,0.236 3.307,0.479 4.89,0.879 0.737,0.187 1.739,0.412 2.874,0.666 -0.008,0.011 -0.016,0.023 -0.024,0.035 -1.741,2.614 -1.676,7.028 2.581,10.544 1.795,1.484 3.868,2.899 5.874,4.267 2.623,1.791 5.335,3.642 7.247,5.54 3.682,3.656 5.728,7.385 6.711,9.177 0.273,0.498 0.478,0.858 0.61,1.053 3.216,4.77 7.734,7.281 13.429,7.462 2.507,0.081 5.059,0.351 7.254,0.598 1.366,0.161 2.61,-0.833 2.764,-2.205 0.154,-1.372 -0.833,-2.61 -2.205,-2.764 -2.292,-0.258 -4.962,-0.54 -7.653,-0.626 -4.056,-0.13 -7.144,-1.85 -9.443,-5.26 -0.082,-0.127 -0.204,-0.357 -0.372,-0.663 -1.011,-1.842 -3.377,-6.155 -7.573,-10.32 -2.236,-2.221 -5.141,-4.204 -7.95,-6.121 -2.001,-1.365 -3.89,-2.655 -5.509,-3.992 -1.867,-1.543 -2.14,-3.113 -1.604,-3.918 0.731,-1.097 3.073,-1.365 6.138,0.249 0.026,0.014 0.052,0.027 0.079,0.04 v 0 h 10e-4 l 0.003,0.002 c 0,0 2.704,1.299 5.411,2.594 1.355,0.647 2.712,1.295 3.73,1.777 0.408,0.193 0.799,0.378 1.172,0.537 l 0.525,0.25 0.018,-0.038 c 1.273,0.453 2.329,0.445 3.169,-0.878 0.679,-1.069 0.449,-2.479 -0.533,-3.279 -0.155,-0.127 -0.324,-0.234 -0.505,-0.32 l -10.627,-5.057 c -1.944,-1.326 -6.039,-2.314 -11.541,-3.545 -1.116,-0.25 -2.103,-0.47 -2.824,-0.652 -1.836,-0.465 -3.73,-0.739 -5.401,-0.981 -1.125,-0.162 -2.187,-0.315 -3.012,-0.498 -2.354,-0.437 -3.181,-2.042 -2.992,-3.447 0.203,-1.511 1.731,-3.171 5.365,-2.86 7.347,0.611 15.859,1.259 23.369,1.83 l 2.174,0.166 c 7.503,0.683 13.557,4.197 16.214,7.375 2.411,2.886 7.991,8.775 10.118,10.681 2.843,2.547 5.929,3.793 10.6,5.678 l 0.161,0.066 C -0.591,5.151 0.865,4.534 1.382,3.254 1.899,1.974 1.28,0.517 0,0 m -78.888,18.366 c 0,3.686 2.999,6.685 6.685,6.685 h 2.096 v 2.097 c 0,3.686 3,6.685 6.686,6.685 3.686,0 6.685,-2.999 6.685,-6.685 v -2.097 h 2.434 c 3.687,0 6.686,-2.999 6.686,-6.685 0,-3.686 -2.999,-6.686 -6.686,-6.686 h -2.434 V 9.247 c 0,-3.687 -2.999,-6.686 -6.685,-6.686 -3.686,0 -6.686,2.999 -6.686,6.686 v 2.433 h -2.096 c -3.686,0 -6.685,3 -6.685,6.686 m 58.984,31.379 c -22.921,12.637 -51.748,4.3 -64.385,-18.621 -12.638,-22.922 -4.301,-51.749 18.621,-64.386 22.921,-12.638 51.748,-4.301 64.386,18.621 12.637,22.922 4.3,51.748 -18.622,64.386",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(23.0816,53.8414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -5.434 c 0,-2.035 1.65,-3.685 3.685,-3.685 2.036,0 3.686,1.65 3.686,3.685 V 0 h 5.434 c 2.035,0 3.685,1.65 3.685,3.685 0,2.036 -1.65,3.686 -3.685,3.686 H 7.371 v 5.096 c 0,2.036 -1.65,3.686 -3.686,3.686 C 1.65,16.153 0,14.503 0,12.467 V 7.371 h -5.096 c -2.036,0 -3.685,-1.65 -3.685,-3.686 C -8.781,1.65 -7.132,0 -5.096,0 Z",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthProfessional);
export default __webpack_public_path__ + "static/media/health_professional.92f73deceb082157f5942f5f7873b210.svg";
export { ForwardRef as ReactComponent };